import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    ...tw`h-2`,
    color: 'var(--sliderColorHex)',
  },
  thumb: tw`h-6 w-6 bg-white border-2 border-solid border-current -mt-3 -ml-3`,
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: tw`rounded`,
  rail: tw`rounded`,
}));
